import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsFunnelMapEmpty } from '../../../../../reducers/united-canvas/unitedCanvasReducer';
import { selectTransientFunnel } from '../../../../../reducers/canvasPageStateReducer';
import { DeprecatedZeroStateRightPanel } from './DeprecatedZeroStateRightPanel';
import { ZeroStateRightPanel } from './ZeroStateRightPanel';
import { ProcessMiningPanel } from '../process-mining/ProcessMiningPanel';
import { DemoChatEntryPoint } from '../../../../../dreamforce-demo/components/DemoChatEntryPoint';
import { useFeatureToggle } from '../../../../../feature-flags/useFeatureToggle';
import { useProcessMining } from '../useProcessMining';
import { usePageHelpers } from '../usePageHelpers';
import { useCanvasFreeElementContext } from '../../../../sweep-canvas/canvas-element-tool/CanvasFreeElementContext';

export const ZeroStateRightPanelWrapper = () => {
  const { processMining, processMiningV2, dreamforceDemo } = useFeatureToggle();
  const isFunnelMapEmpty = useSelector(selectIsFunnelMapEmpty);
  const transientFunnel = useSelector(selectTransientFunnel);
  const { funnelMapId, isLoading: isPageLoading } = usePageHelpers();
  const { clearState } = useProcessMining(funnelMapId || '');

  const [isOpen_deprecated, setIsOpen_deprecated] = useState(isFunnelMapEmpty);
  const { isCreatingFreeElement } = useCanvasFreeElementContext();

  const onClose_deprecated = useCallback(() => {
    setIsOpen_deprecated(false);
  }, []);

  useEffect(() => {
    if (isFunnelMapEmpty) {
      setIsOpen_deprecated(true);
    } else {
      setIsOpen_deprecated(false);
    }
  }, [isFunnelMapEmpty]);

  // Handles ProcessMining cleanup cases: 1. successful completion, 2. stale/leftover
  useEffect(() => {
    if (!isFunnelMapEmpty && !!funnelMapId) {
      clearState();
    }
  }, [isFunnelMapEmpty, funnelMapId, clearState]);

  const isProcessMiningOpen = isFunnelMapEmpty && !transientFunnel && !isPageLoading;

  //This condition will de deleted when we remove feature toggles
  if ((dreamforceDemo || !processMiningV2) && (!isOpen_deprecated || transientFunnel)) {
    return null;
  }

  if (isCreatingFreeElement) {
    return null;
  }

  if (dreamforceDemo) {
    return <DemoChatEntryPoint onClose={onClose_deprecated} />;
  }

  if (processMiningV2) {
    return <ProcessMiningPanel isOpen={isProcessMiningOpen} />;
  }

  if (processMining) {
    return <ZeroStateRightPanel onClose={onClose_deprecated} />;
  }

  return <DeprecatedZeroStateRightPanel onClose={onClose_deprecated} />;
};
